import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { queryTypes, servicesMuhimmatIndekslerTypes } from 'src/types';
import { urlHelper } from 'src/app/helpers';
import { axios, axiosc } from 'src/app/utils';

export const muhimmatIndekslerLookup = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesMuhimmatIndekslerTypes.MuhimmatIndekslerLookupDataType): AxiosPromise<servicesMuhimmatIndekslerTypes.MuhimmatIndekslerLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.muhimmat.muhimmatIndeksler), {
    blockSpinner,
  });
};

export const muhimmatIndekslerCreate = (
  form: servicesMuhimmatIndekslerTypes.MuhimmatIndekslerCreateDataType,
): AxiosPromise<servicesMuhimmatIndekslerTypes.MuhimmatIndekslerCreateResultType> => {
  return axiosc.post(urlsConfig.generics.muhimmat.muhimmatIndeksler, form, { blockErrorHandler: true });
};

export const muhimmatIndekslerEdit = (
  form: servicesMuhimmatIndekslerTypes.MuhimmatIndekslerEditDataType,
): AxiosPromise<servicesMuhimmatIndekslerTypes.MuhimmatIndekslerEditResultType> => {
  return axiosc.patch(urlsConfig.generics.muhimmat.muhimmatIndeksler, form, { blockErrorHandler: true });
};

export const muhimmatIndekslerDelete = ({
  id,
}: servicesMuhimmatIndekslerTypes.MuhimmatIndekslerDeleteDataType): AxiosPromise<servicesMuhimmatIndekslerTypes.MuhimmatIndekslerDeleteResultType> => {
  return axiosc.delete(`${urlsConfig.generics.muhimmat.muhimmatIndeksler}/${id}`);
};
